module.exports = __webpack_public_path__ + "static/media/traktor_2.6093acb3.png";